import React from 'react';

const MARKETPLACES = [
  { id: 'all', label: 'Все', color: '' },
  { id: 'wb', label: 'WB', color: 'text-purple-600' },
  { id: 'ozon', label: 'Ozon', color: 'text-blue-500' },
  { id: 'avito', label: 'Авито', color: 'text-emerald-600' },
  { id: 'avito_ads', label: 'Avito Ads', color: 'text-orange-500' },
];

export default function MarketplaceFilter({ value = 'all', onChange, available }) {
  const items = available
    ? MARKETPLACES.filter((m) => m.id === 'all' || available.includes(m.id))
    : MARKETPLACES;

  return (
    <div className="inline-flex gap-0.5 p-1 rounded-lg bg-[var(--wb-surface-muted)] border border-[var(--wb-border)]">
      {items.map((m) => (
        <button
          key={m.id}
          type="button"
          onClick={() => onChange(m.id)}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
            value === m.id
              ? 'bg-white shadow-sm text-[var(--wb-text-primary)] dark:bg-[var(--wb-surface-raised)]'
              : 'text-[var(--wb-text-muted)] hover:text-[var(--wb-text-secondary)]'
          } ${m.color}`}
        >
          {m.id === 'wb' && <span className="inline-block w-2 h-2 rounded-full bg-purple-500 mr-1.5" />}
          {m.id === 'ozon' && <span className="inline-block w-2 h-2 rounded-full bg-blue-500 mr-1.5" />}
          {m.id === 'avito' && <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 mr-1.5" />}
          {m.id === 'avito_ads' && <span className="inline-block w-2 h-2 rounded-full bg-orange-500 mr-1.5" />}
          {m.label}
        </button>
      ))}
    </div>
  );
}

export function MarketplaceBadge({ marketplace }) {
  if (marketplace === 'wb') {
    return <span className="inline-flex items-center gap-1 text-xs font-medium text-purple-600"><span className="w-1.5 h-1.5 rounded-full bg-purple-500" />WB</span>;
  }
  if (marketplace === 'ozon') {
    return <span className="inline-flex items-center gap-1 text-xs font-medium text-blue-500"><span className="w-1.5 h-1.5 rounded-full bg-blue-500" />Ozon</span>;
  }
  if (marketplace === 'avito') {
    return <span className="inline-flex items-center gap-1 text-xs font-medium text-emerald-600"><span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />Авито</span>;
  }
  if (marketplace === 'avito_ads') {
    return <span className="inline-flex items-center gap-1 text-xs font-medium text-orange-500"><span className="w-1.5 h-1.5 rounded-full bg-orange-500" />Avito Ads</span>;
  }
  return null;
}
